import { useSyncExternalStore } from 'react';

export const MINUTE_TICK_MS = 60_000;

// One interval shared by every subscriber, running only while at least one
// component is mounted. Components that read the current time through this
// hook re-render once a minute without re-rendering their parents.
let now = Date.now();
let intervalId: ReturnType<typeof setInterval> | undefined;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  if (intervalId === undefined) {
    now = Date.now();
    intervalId = setInterval(() => {
      now = Date.now();
      listeners.forEach((l) => l());
    }, MINUTE_TICK_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && intervalId !== undefined) {
      clearInterval(intervalId);
      intervalId = undefined;
    }
  };
};

const getSnapshot = () => now;

export const useMinuteTick = (): number =>
  useSyncExternalStore(subscribe, getSnapshot);
